// extracted by mini-css-extract-plugin
export default {"container":"CN-z","error":"DN-z","disabled":"EN-z","submit":"FN-z","option":"GN-z","success":"HN-z","failure":"IN-z"};